import { client } from "../../../api/client";

export const fetchImportTemplateByFilter = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_importTemplateData.json");
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/importtemplate/filter", body);
            return response.data;
        } catch (error) {
            console.error("Error fetching import template:", error);
            return [];
        }
    }
}

export const createImportTemplate = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "templatesapi/importtemplate", body);
            return response.data;
        } catch (error) {
            console.error("Error creating import template:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};

export const deleteImportTemplate = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.delete(process.env.REACT_APP_GATEWAY_URI, `templatesapi/importtemplate/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting import template:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};


export const updateImportTemplate = async (id, body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `templatesapi/importtemplate/${id}`, body);
            return response.data;
        } catch (error) {
            console.error("Error updating import template:", error);
            return [];
        }
    }
};

export const replaceImportTemplateFile = async (id, body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `templatesapi/importtemplate/replacefile/${id}`, body);
            return response.data;
        } catch (error) {
            console.error("Error replacing import template file:", error);
            return [];
        }
    }
};

export const importTemplate = async (body, importTemplateId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return null;
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `importexportapi/iquote/importtemplate/${importTemplateId}`, body);
            return response.data;
        } catch (error) {
            console.error("Error importing template:", error);
            return [];
        }
    }
};

export const exportDataAsExcel = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return null;
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `importexportapi/iquote/exportAsExcel/`, body);
            return response.data;
        } catch (error) {
            console.error("Error importing template:", error);
            return [];
        }
    }
};

export const importTemplateTest = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return null;
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, 'importexportapi/iquote/importtemplate/test', body);
            return response.data;
        } catch (error) {
            console.error("Error importing template:", error);
            return [];
        }
    }
};

export const getAWSSettings = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/importtemplate/getawssettings');
            return response.data;
        } catch (error) {
            console.error("Error getting AWS Settings:", error);
            return [];
        }
    }
};

export const getPreSignedUrl = async (key) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, 'templatesapi/importtemplate/presignedurl/key', key);
            return response.data;
        } catch (error) {
            console.error("Error getting presigned url:", error);
            return [];
        }
    }
};